import React from 'react';
import Modal from 'bootstrap/js/dist/modal';
import CryptoJS from 'crypto-js';

export const handleNonDecimalEvent = event => {
	if (event.which < 48 || event.which > 57) {
		event.preventDefault();
	}
};

export const getDateFormated = newDate => {
	if (!newDate) return '-';
	const d = new Date(newDate);

	const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	const day = d.getDate();
	const month = d.getMonth();
	const year = d.getFullYear();
	if (day || month || year) {
		return `${day} ${monthNames[month]} ${year}`;
	} else {
		return null;
	}
};

export const getDateFormatedByDayNames = newDate => {
	if (!newDate) return '-';
	const d = new Date(newDate);
	const daysInWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

	const monthNames = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December'
	];
	const date = d.getDate();
	const day = d.getDay();
	const month = d.getMonth();
	return { date: date, day: daysInWeek[day], month: monthNames[month] };
};

// Generating a 64-character secure key that changes every week (7 days)

const secureKey = CryptoJS.PBKDF2('Secret Passphrase', 'Salt', {
	keySize: 64 / 8,
	iterations: 7 * 24 * 60 * 60 // 7 days
}).toString();

// Function to encrypt data
export const encryptData = data => {
	const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), secureKey).toString();
	return ciphertext;
};

// Function to decrypt data
export const decryptData = ciphertext => {
	try {
		const bytes = CryptoJS.AES.decrypt(ciphertext, secureKey);
		const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
		return decryptedData;
	} catch (error) {
		return null;
	}
};

export const loadState = itemName => {
	try {
		const encryptedState = localStorage.getItem(itemName);

		if (!encryptedState) {
			return undefined;
		}

		const decryptedState = decryptData(encryptedState);

		if (decryptedState === null) {
			return undefined;
		}

		return decryptedState;
	} catch (error) {
		console.error(error);
		return undefined;
	}
};

export const saveState = (state, itemName) => {
	try {
		const serializedState = encryptData(state);
		localStorage.setItem(itemName, serializedState);
	} catch (error) {
		console.error(error);
	}
};
export const currencyFormat = num => {
	if (!num) return '-';
	return new Intl.NumberFormat('en-US').format(num);
};
export const currencyFormatInputs = num => {
	if (!num) return '0';
	const number = num.split(',').join('');
	return Number(String(number).replace(/[^0-9.,-]+/g, '')).toLocaleString(undefined, {
		currencyDisplay: 'symbol'
	});
};

export const removeState = itemName => {
	try {
		localStorage.removeItem(itemName);
	} catch (error) {
		console.error(error);
	}
};

export const isTokenExpired = expirationDate => {
	const now = new Date();
	const expireDate = new Date(expirationDate);
	return now.getTime() > expireDate.getTime();
};

export const handleError = err => {
	console.log('err', err);
	if (err.status === 500) {
		return "Error! Can't perform this action at the moment. Please try again later.";
	} else if (err?.data?.errors) {
		return Object.keys(err?.data?.errors).map(key => (
			<span className='d-block mb-1' key={key}>
				{err?.data?.errors[key]}
			</span>
		));
	} else if (err.originalStatus === 404) {
		return "Error! Can't perform this action at the moment. Please try again later.";
	} else {
		return err?.message ? err?.message : err?.error?.data?.message;
	}
};

export const langRegex = () => {
	return {
		enRegex: /^(?=.*[A-Z0-9])[\w.,!"'/$ ]+$/im,
		arRegex:
			/[\u0600-\u06ff]|[\u0750-\u077f]|[\ufb50-\ufbc1]|[\ufbd3-\ufd3f]|[\ufd50-\ufd8f]|[\ufd92-\ufdc7]|[\ufe70-\ufefc]|[\uFDF0-\uFDFD]/
	};
};

export const setLoadingApi = () => {
	return [
		{
			endpointName: 'login'
		},
		{
			endpointName: 'resendEmailOTP'
		},
		{
			endpointName: 'verifyByOtp'
		},
		{
			endpointName: 'logout'
		},
		{
			endpointName: 'addCompany'
		},
		{
			endpointName: 'approveCompany'
		},
		{
			endpointName: 'editCompany'
		},
		{
			endpointName: 'resubmitCompany'
		},
		{
			endpointName: 'blockCompany'
		},

		{
			endpointName: 'unblockCompany'
		},
		{
			endpointName: 'blockLoan'
		},
		{
			endpointName: 'unBlockLoanCompany'
		},
		{
			endpointName: 'attachUserToCompany'
		},
		{
			endpointName: 'dettachUserFromCompany'
		},

		{
			endpointName: 'editCompanyBankAccounts'
		},
		{
			endpointName: 'createCompanyBankAccount'
		},
		{
			endpointName: 'deleteCompanyBank'
		},
		{
			endpointName: 'rejectCompany'
		},
		{
			endpointName: 'rejectRequest'
		},
		{
			endpointName: 'resubmitCompany'
		},
		{
			endpointName: 'approveRequest'
		},
		{
			endpointName: 'approveCompanies'
		},
		{
			endpointName: 'blockCompanies'
		},
		{
			endpointName: 'unBlockCompanies'
		},
		{
			endpointName: 'blockLoansCompanies'
		},
		{
			endpointName: 'unBlockLoanCompanies'
		},
		{
			endpointName: 'rejectCompanies'
		},
		{
			endpointName: 'filterCompanies'
		},
		{
			endpointName: 'editBankAccount'
		},
		{
			endpointName: 'deleteBankAccount'
		},
		{
			endpointName: 'addBankAccount'
		},
		{
			endpointName: 'addRole'
		},
		{
			endpointName: 'editRoleById'
		},
		{
			endpointName: 'deleteRole'
		},

		{
			endpointName: 'getFilteredUsers'
		},
		{
			endpointName: 'addUserAdmin'
		},
		{
			endpointName: 'editUserAdmin'
		},
		{
			endpointName: 'deleteUser'
		},
		{
			endpointName: 'getFilteredCompanyUsers'
		},
		{
			endpointName: 'addUserCompany'
		},
		{
			endpointName: 'deleteCompanyUser'
		},
		{
			endpointName: 'editUserCompany'
		},
		{
			endpointName: 'addIndustry'
		},
		{
			endpointName: 'deleteIndustry'
		},
		{
			endpointName: 'addLegalStructure'
		},
		{
			endpointName: 'deleteLegalStructure'
		},
		{
			endpointName: 'addCompanySize'
		},
		{
			endpointName: 'deleteCompanySize'
		},
		{
			endpointName: 'getFilteredPrograms'
		},

		{
			endpointName: 'addProgram'
		},

		{
			endpointName: 'approveProgramRequest'
		},
		{
			endpointName: 'rejectProgramRequest'
		},
		{
			endpointName: 'rejectProgram'
		},
		{
			endpointName: 'editProgram'
		},
		{
			endpointName: 'attachCompaniestoProgram'
		},
		{
			endpointName: 'detachCompaniesfromProgram'
		},
		{
			endpointName: 'blockProgram'
		},
		{
			endpointName: 'unBlockProgram'
		},
		{
			endpointName: 'resubmitProgram'
		},
		{
			endpointName: 'approveProgram'
		}
	];
};

export const hideOppenedModal = () => {
	let oppenedModal = document.querySelector('.modal.show');

	if (oppenedModal) {
		Modal.getOrCreateInstance(oppenedModal).hide();
	}

	return;
};

export const setGridWidth = collapseToggle => {
	let sidebarWidth;
	let windowWidth = window.innerWidth / 16;

	if (collapseToggle) {
		sidebarWidth = 5.5625;
	} else {
		sidebarWidth = 23.6875;
	}

	document.querySelector('.grid-con').style.width = windowWidth - sidebarWidth - 5.376 + 'rem';
};

export const checkPermission = (permissions, name) => {
	return !!permissions?.find(permission => permission.name === name);
};

export const getCurrentToken = () => {
	const STORAGE_KEY = 'cayesh_user_loggged';
	const storedUser = loadState(STORAGE_KEY);
	return storedUser?.token;
};
export const eleminateSpecialCharacters = (sample = '') => {
	const pattern = new RegExp("[$&+,:;=?@#|/'<>.^*()%!-]");
	return sample
		.split('')
		.filter(char => char.replace(pattern, ''))
		.join('');
};

// get the currency symbol from the environment variable
// utils.js
export const getCurrencySymbol = language => {
	if (language === 'ar') {
		return process.env.REACT_APP_CURRENCY_SYMBOL_AR || 'جنيه';
	} else {
		return process.env.REACT_APP_CURRENCY_SYMBOL_EN || 'EGP';
	}
};
